import Glider from "glider-js";

(function ($) {
  $(document).on("ready", () => {
    // ? info: ANNOUNCEMENTS slider handled in announcements.js

    // SCHEDULE mega modal
    // ?info: SCHEDULE item sliders handled in live-schedule.js
    let megaModal = document.querySelector(".schedule-mega-modal__slider");
    if (megaModal !== null) {
      const megaGlider = new Glider(megaModal, {
        slidesToShow: 1,
        slidesToScroll: 1,
        scrollLock: true,
        dots: false,
        arrows: false,
        duration: 1
      });

      // Disable arrows manually since there are multiple next/prev links
      $('.schedule-mega-modal__slider .slide-wrapper:first-child .prev-arrow').addClass('disabled');
      $('.schedule-mega-modal__slider .slide-wrapper:last-child .next-arrow').addClass('disabled');

      // Custom pagination since there are multiple next/prev links
      $(".schedule-mega-modal .schedule-event-details .prev-arrow").on('click',function() {
        let currSlide = megaGlider.slide;
        let prevSlide = currSlide--;

        if (prevSlide > 0)
          megaGlider.scrollItem(currSlide--);
      });

      $(".schedule-mega-modal .schedule-event-details .next-arrow").on('click',function() {
        let currSlide = megaGlider.slide;
        let nextSlide = currSlide++;

        if (currSlide !== megaGlider.slides.length)
          megaGlider.scrollItem(currSlide++);
      });

      // Disable schedule prev/next buttons links if only one item
      if (WP.schedule.scheduleItems.length === 1) {
        document.querySelector('.schedule-mega-modal .schedule-event-details__nav').style.display = 'none';
      }
    }

    // Clips slider
    $(".clips-list").each(function (key) {
      let section = this.closest(".event-section");
      let slider = this;
      let sliderNav = section.querySelector(".clips-nav");

      if (sliderNav === null)
        return false;

      slider.id = "clip-slider-" + key;
      sliderNav.id = "clip-slider-nav" + key;

      if (!section.classList.contains("grid-view")) {
        // initialize glider
        initializeClipsGlider(slider);
      }
    });

    // Sponsors slider
    $(".sponsors-list").each(function (key) {
      let section = this.closest(".event-section");
      let slider = this;
      let sliderNav = section.querySelector(".sponsors-nav");

      slider.id = "sponsor-slider-" + key;
      sliderNav.id = "sponsor-slider-nav" + key;

      let glider = new Glider(slider, {
        slidesToShow: 'auto',
        slidesToScroll: 'auto',
        dots: sliderNav,
        itemWidth: 75,
        exactWidth: false,
        duration: 2,
        responsive: [
          {
            breakpoint: 450,
            settings: {
              itemWidth: 150
            }
          }
        ]
      });

      // check endcap once loaded
      glider.ele.addEventListener("glider-refresh",function(e) {
        checkEndcap(this);
        checkSponsorsNav(this);
        autoplayGlider(glider, 10000);
      });

      glider.refresh();
    });

    // Clips view toggle
    $(".js-clips-grid-toggle").on("click", function () {
      let section = this.closest(".event-section");
      let slider = section.querySelector('.clips-list');

      if (slider.classList.contains('glider')) {
        // TOGGLE TO GRID
        Glider(document.querySelector('#' + slider.id)).destroy();
        section.classList.add("grid-view");
      } else {
        // TOGGLE TO SCROLL

        // clone & replace arrows (glider destroy event breaks them)
        let oldSliderArrows = jQuery(section).find('.clips-nav-arrows');
        let newSliderArrows = oldSliderArrows.clone();
        oldSliderArrows.replaceWith(newSliderArrows);

        // re-instantiate glider
        initializeClipsGlider(slider);
        section.classList.remove("grid-view");
      }
    });
  });
})(jQuery);

// HELPER: Initialize clips glider
function initializeClipsGlider(slider) {
  let section = slider.closest(".event-section");

  let sliderNav = section.querySelector(".clips-nav");
  let sliderNavPrev = sliderNav.querySelector(".prev-arrow");
  let sliderNavNext = sliderNav.querySelector(".next-arrow");

  let glider = new Glider(slider, {
    slidesToShow: 'auto',
    slidesToScroll: 'auto',
    arrows: {
      prev: sliderNavPrev,
      next: sliderNavNext
    },
    itemWidth: 261, // 245 + margin
    exactWidth: true,
    duration: 1
  });

  // check endcap once loaded
  glider.ele.addEventListener("glider-refresh",function() {
    checkEndcap(this);
  });

  glider.refresh();
}

// HELPER: Autoplay slider
function autoplayGlider(slider, autoplayDelay = 5000) {
  let autoplay = setInterval(() => {
      slider.scrollItem('next')
  }, autoplayDelay);

  slider.ele.addEventListener('mouseover', () => {
      if (autoplay != null) {
        clearInterval(autoplay);
        autoplay = null;
      }
  }, 300);

  slider.ele.addEventListener('mouseout', () => {
      if (autoplay == null) {
        autoplay = setInterval(() => {
            slider.scrollItem('next')
        }, autoplayDelay);
      }
  }, 300);
}

// HELPER: Remove endcap if there's only one page
export function checkEndcap(slider) {
  const contentWrapper = slider.closest(".event-section-content"),
    lastItem = slider.querySelector(".glider-slide:last-of-type");

  if (!lastItem) {
    contentWrapper.classList.add("no-endcap");
    return;
  }

  let lastItemRect = lastItem.getBoundingClientRect(),
      lastItemLeft = lastItemRect.left + window.scrollX,
      lastItemEdge = lastItemLeft + lastItem.offsetWidth,
      sliderBounds = slider.offsetWidth;

  if (lastItemEdge < sliderBounds) {
    contentWrapper.classList.add("no-endcap");
  } else {
    contentWrapper.classList.remove("no-endcap");
  }
}

// HELPER: Remove sponsors nav if there's only one page
export function checkSponsorsNav(slider) {
  const contentWrapper = slider.closest(".event-section-content"),
    lastItem = slider.querySelector(".glider-slide:last-of-type"),
    sponsorsNav = document.querySelector(".sponsors-nav");

  if (!lastItem) {
    sponsorsNav.style.display = 'flex';
    return;
  }

  let lastItemRect = lastItem.getBoundingClientRect(),
      lastItemLeft = lastItemRect.left + window.scrollX,
      lastItemEdge = lastItemLeft + lastItem.offsetWidth,
      sliderBounds = slider.offsetWidth;

  if (lastItemEdge < sliderBounds) {
    sponsorsNav.style.display = 'none';
  } else {
    sponsorsNav.style.display = 'flex';
  }
}